import React, { useEffect, useState } from "react";
import {
  Grid,
  Box,
  Button,
  Avatar,
  TextField,
  InputAdornment,
  Typography,
  ToggleButtonGroup,
  ToggleButton,
} from "@mui/material";
import Snackbar1 from "../../../../../components/ui/Snackbar";
import WhatsApps from "../../../../../assets/images/watsapp.png";
import Facebooks from "../../../../../assets/images/facebook.png";
import InstagramIcon from "../../../../../assets/images/instagram.png";
import YouTubeIcon from "../../../../../assets/images/youtube.png";
import LinkedInIcon from "../../../../../assets/images/linkdin.png";
import PinterestIcon from "../../../../../assets/images/pintrest.png";
import LanguageIcon from "../../../../../assets/images/website.png";
import LocationOnIcon from "../../../../../assets/images/google review.png";
import TelegramIcon from "../../../../../assets/images/telegram.png";
import TwitterIcon from "../../../../../assets/images/x.png";
import PictureAsPdfIcon from "../../../../../assets/images/pdf.png";
import snapchatIcon from "../../../../../assets/images/snapchat.png";
import LoaderCon from "../../../../../components/ui/LoaderContainer";
import mobileIcon from "../../../../../assets/images/mobile.png";
import skypIcon from "../../../../../assets/images/skype.png";
import massengerIcon from "../../../../../assets/images/massenger.png";
import wechatIcon from "../../../../../assets/images/wechat-logo-png-transparent.png";
import FaceTimeIcon from "../../../../../assets/images/facetime-ios.png";
import { Link, useNavigate } from "react-router-dom";

const socialFields = [
  { label: "Facebook Link", key: "Facebook", type: "text", icon: Facebooks },
  {
    label: "Instagram Link",
    key: "Instagram",
    type: "text",
    icon: InstagramIcon,
  },
  {
    label: "WhatsApp Number",
    key: "WhatsApp",
    type: "number",
    icon: WhatsApps,
  },
  { label: "Browser Link", key: "Browser", type: "text", icon: LanguageIcon },
  { label: "Snapchat Link", key: "Snapchat", type: "text", icon: snapchatIcon },
  { label: "Twitter Link", key: "Twitter", type: "text", icon: TwitterIcon },
  { label: "LinkedIn Link", key: "LinkedIn", type: "text", icon: LinkedInIcon },
  { label: "Telegram Link", key: "Telegram", type: "text", icon: TelegramIcon },
  { label: "YouTube Link", key: "YouTube", type: "text", icon: YouTubeIcon },
  {
    label: "Pinterest Link",
    key: "Pinterest",
    type: "text",
    icon: PinterestIcon,
  },
  {
    label: "PDF Downloader Link",
    key: "PDFDownloader",
    type: "text",
    icon: PictureAsPdfIcon,
  },
  { label: "Mobile Number", key: "mobile", type: "number", icon: mobileIcon },
  { label: "Skype Link", key: "Skype", type: "text", icon: skypIcon },
  {
    label: "Messenger Link",
    key: "massenger",
    type: "text",
    icon: massengerIcon,
  },
  { label: "Wechat Link", key: "wechat", type: "text", icon: wechatIcon },
  {
    label: "FaceTime Number",
    key: "FaceTime",
    type: "number",
    icon: FaceTimeIcon,
  },
  {
    label: "Google Review Link",
    key: "GoogleMaps",
    type: "text",
    icon: LocationOnIcon,
  },
];

export default function EditProfile({
  close_snack_bar,
  snackbar,
  client,
  login,
  UploadupdateLink,
  viewLinkById,
}) {
  const navigate = useNavigate();

  const initialLinks = client.allLinksByAdmin || {};

  const [formData, setFormData] = useState({
    Facebook: initialLinks.Facebook || "",
    Instagram: initialLinks.Instagram || "",
    WhatsApp: initialLinks.WhatsApp || "",
    Browser: initialLinks.Browser || "",
    Snapchat: initialLinks.Snapchat || "",
    GoogleMaps: initialLinks.GoogleMaps || "",
    Twitter: initialLinks.Twitter || "",
    LinkedIn: initialLinks.LinkedIn || "",
    Telegram: initialLinks.Telegram || "",
    YouTube: initialLinks.YouTube || "",
    Pinterest: initialLinks.Pinterest || "",
    PDFDownloader: initialLinks.PDFDownloader || "",
    mobile: initialLinks.mobile || "",
    BusinessWhatsApp: initialLinks.BusinessWhatsApp || "",
    Skype: initialLinks.Skype || "",
    massenger: initialLinks.massenger || "",
    wechat: initialLinks.wechat || "",
    FaceTime: initialLinks.FaceTime || "",
    heading: initialLinks.heading || "",
    tagLine: initialLinks.tagLine || "",
    showAllReviews: initialLinks.showAllReviews || false,
  });

  const [link_id] = useState(initialLinks._id);
  const [mediaType] = useState(initialLinks.mediaType);
  const [profileImage, setProfileImage] = useState(initialLinks.profileImage);
  const [coverImage, setCoverImage] = useState(initialLinks.coverImage);
  const [newprofileImage, setNewProfileImage] = useState(null);
  const [newcoverImage, setNewCoverImage] = useState(null);
  const [profilePreview, setProfilePreview] = useState("");
  const [coverPreview, setCoverPreview] = useState(null);

  useEffect(() => {
    document.body.style.background = "rgba(3, 22, 52, 0.1)";
    if (login.token && login.user_id) {
      viewLinkById(login.user_id, login.token);
    }
  }, [login.token, login.user_id, viewLinkById]);

  const handleChange = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleFileupdates = (e, type) => {
    const file = e.target.files[0];

    if (file) {
      const supportedImageTypes = ["image/jpeg", "image/png", "image/gif"];
      const supportedVideoTypes = ["video/mp4", "video/webm"];
      const maxSize = 5 * 1024 * 1024; // 5MB limit

      // Validate file size
      if (file.size > maxSize) {
        alert("File size must not exceed 5MB.");
        return;
      }

      // Validate file type based on input type
      if (
        (type === "profile" && !supportedImageTypes.includes(file.type)) ||
        (type === "cover" &&
          ![...supportedImageTypes, ...supportedVideoTypes].includes(file.type))
      ) {
        alert("Unsupported file type. Please upload a valid file.");
        return;
      }

      // Read file and update state
      const reader = new FileReader();
      reader.onload = (event) => {
        if (type === "profile") {
          // Update state for profile image
          setNewProfileImage(file);
          setProfileImage(null);
          setProfilePreview(event.target.result); // Preview URL
        } else if (type === "cover") {
          // Update state for cover image/video
          setNewCoverImage(file);
          setCoverImage(null);
          setCoverPreview({
            src: event.target.result, // Preview URL
            type: file.type.startsWith("image") ? "image" : "video", // Detect type
            mediaType: file.type.startsWith("image") ? "image" : "video", // Detect type
          });
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const handleEditSubmit = (e) => {
    e.preventDefault();

    UploadupdateLink(
      login.token,
      login.user_id,
      link_id,
      formData.Facebook,
      formData.Instagram,
      formData.WhatsApp,
      formData.Browser,
      formData.Snapchat,
      formData.GoogleMaps,
      formData.Twitter,
      formData.LinkedIn,
      formData.Telegram,
      formData.YouTube,
      formData.Pinterest,
      formData.PDFDownloader,
      formData.heading,
      coverPreview?.mediaType || mediaType,
      formData.mobile,
      formData.BusinessWhatsApp,
      formData.Skype,
      formData.massenger,
      formData.wechat,
      formData.FaceTime,
      coverImage,
      newcoverImage,
      profileImage,
      newprofileImage,
      formData.showAllReviews,
      formData.tagLine,
      login.login_id
    );

    navigate("/");
  };

  return (
    <Box>

      <Box display="flex" alignItems="center" p={2}>
        <Link to="/">
          <Button variant="text" sx={{ color: "#000", fontWeight: 600 }}>
            Links
          </Button>
        </Link>
        /
        <Button variant="text" sx={{ color: "#000", fontWeight: 800 }}>
          Edit Links
        </Button>
      </Box>

      <form onSubmit={handleEditSubmit}>
        <Grid sx={{ px: 3 }}>
          <Grid container direction="column" spacing={3}>

            <Grid item>
              <Box
                sx={{
                  position: "relative",
                  border: "1px solid #ddd",
                  overflow: "hidden",
                  width: "100%",
                  maxHeight: "300px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {coverPreview ? (
                  coverPreview.type === "image" ? (
                    <Box
                      component="img"
                      src={coverPreview.src}
                      alt="Cover"
                      sx={{ width: "100%", objectFit: "cover" }}
                    />
                  ) : (
                    <Box
                      component="video"
                      src={coverPreview.src}
                      autoPlay
                      muted
                      loop
                      sx={{ width: "100%" }}
                    />
                  )
                ) : mediaType === "image" ? (
                  <Box
                    component="img"
                    src={coverImage}
                    alt="Cover"
                    sx={{ width: "100%", objectFit: "cover" }}
                  />
                ) : (
                  <Box
                    component="video"
                    src={coverImage}
                    autoPlay
                    muted
                    loop
                    sx={{ width: "100%" }}
                  />
                )}
              </Box>
            </Grid>

            <Grid item mt={5}>
              <TextField
                size="small"
                fullWidth
                variant="outlined"
                type="file"
                accept="image/*,video/*"
                onChange={(e) => handleFileupdates(e, "cover")}
                helperText="Upload a cover (image/video, max 5MB)"
              />
            </Grid>


            <Grid item>
              <Box display="flex" justifyContent="center">
                <Avatar
                  src={profilePreview || profileImage}
                  sx={{
                    width: { xs: 80, sm: 120, md: 140 },
                    height: { xs: 80, sm: 120, md: 140 },
                    border: "2px solid white",
                    boxShadow: 1,
                  }}
                />
              </Box>
            </Grid>

            <Grid item>
              <TextField
                size="small"
                fullWidth
                variant="outlined"
                type="file"
                accept="image/*"
                onChange={(e) => handleFileupdates(e, "profile")}
                helperText="Upload a profile picture (JPEG, PNG)"
              />
            </Grid>


            <Grid item xs={12}>
              <TextField
                size="small"
                fullWidth
                variant="outlined"
                label="Brand Name"
                value={formData.heading}
                onChange={(e) => handleChange("heading", e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                size="small"
                fullWidth
                variant="outlined"
                label="Tag Line"
                value={formData.tagLine}
                onChange={(e) => handleChange("tagLine", e.target.value)}
              />
            </Grid>


            <Grid container item spacing={2}>
              {socialFields.map((field) => (
                <Grid item xs={12} sm={6} key={field.key}>
                  <TextField
                    size="small"
                    fullWidth
                    variant="outlined"
                    label={field.label}
                    type={field.type}
                    value={formData[field.key] || ""}
                    onChange={(e) => handleChange(field.key, e.target.value)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <img
                            src={field.icon}
                            alt={field.key}
                            style={{ width: 24, height: 24 }}
                          />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
              ))}
            </Grid>
            <Grid item>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "10px 15px",
                  border: "1px solid #ccc",
                  borderRadius: "10px",
                  backgroundColor: "#f9f9f9",
                }}
              >
                <Typography sx={{ fontSize: 14 }}>
                  Filter Bad Reviews ?
                </Typography>
                <ToggleButtonGroup
                  value={formData.showAllReviews}
                  exclusive
                  onChange={(e, val) => {
                    if (val !== null) handleChange("showAllReviews", val); // keep boolean
                  }}
                  sx={{ ml: 2 }}
                >

                  <ToggleButton
                    value={true}
                    size="small"
                    sx={{
                      fontSize: 12,
                      px: 2,
                      borderRadius: 20,
                      backgroundColor: formData.showAllReviews
                        ? "#4caf50"
                        : "#fff",
                      color: formData.showAllReviews ? "#fff" : "#000",
                      "&.Mui-selected": {
                        backgroundColor: "#4caf50",
                        color: "#fff",
                      },
                    }}
                  >
                    Yes
                  </ToggleButton>


                  <ToggleButton
                    value={false}
                    size="small"
                    sx={{
                      fontSize: 12,
                      px: 2,
                      borderRadius: 20,
                      backgroundColor:
                        formData.showAllReviews === false ? "#f44336" : "#fff",
                      color:
                        formData.showAllReviews === false ? "#fff" : "#000",
                      "&.Mui-selected": {
                        backgroundColor: "#f44336",
                        color: "#fff",
                      },
                    }}
                  >
                    No
                  </ToggleButton>
                </ToggleButtonGroup>
              </Box>
            </Grid>
          </Grid>
        </Grid>


        <Box display="flex" justifyContent="center" gap={2} py={2}>
          <Button
            type="submit"
            variant="contained"
            sx={{ backgroundColor: "#000", color: "#FFF", fontWeight: 800 }}
          >
            Save Changes
          </Button>
          <Link to="/">
            <Button
              variant="outlined"
              sx={{ border: "1px solid #000", color: "#000", fontWeight: 800 }}
            >
              Preview
            </Button>
          </Link>
        </Box>
      </form>

      <LoaderCon />
      <Snackbar1
        open={snackbar?.response_received}
        message={snackbar?.message}
        close_snack_bar={close_snack_bar}
      />
    </Box>
  );
}
